import applicationStore from './application/index';
import accountsStore from './accounts/index';
import bastanteoStore from './bastanteo/index';
import formStore from './form/index';
import loaderStore from './loader/index';
import fullscreenStore from './fullscreen/index';
import Vue from 'vue';
import Vuex from 'vuex';
import yuriMenuStore from './yuri-menu/index';
import conciliationStore from './conciliation/index';
import conciliation2Store from './conciliation2/index';
import countriesStore from './countries/index';
import configVarsStore from './config-vars/index';
import meStore from './me/index';

Vue.use(Vuex);

const store = new Vuex.Store({
    modules: {
        applicationStore,
        accountsStore,
        loaderStore,
        yuriMenuStore,
        bastanteoStore,
        formStore,
        fullscreenStore,
        conciliationStore,
        conciliation2Store,
        countriesStore,
        configVarsStore,
        meStore
    }
});

export default store;
